import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function Marketing() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Marketing" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Marketing</h2>
              <p>
                <strong>Studijski program:</strong> Računovodstvo finansije i
                bankarstvo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Marketing
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Ekonomija
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Upoznavanje studenata sa osnovnim determinantama tržišnog
                poslovanja preduzeća. Osposobljavanje studenata za primjenu
                ključnih komponenti politike pojedinih elemenata marketing miksa
                (proizvod, cijena, distribucija i promocija) kao i njihovu
                integraciju u konzistentan marketing program. Osposobljavanje
                studenata za upotrebu ključnih instrumenata upravljanja
                marketingom (planiranje, organizovanje, kontrola) sa akcentom na
                metodama optimizacije komponenti i cjeline mikrosistema
                marketinga.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Predmet Marketing je osnovna disciplina neophodna za kasnije
                uspješno izučavanje specijalnih marketing disciplina. Pored
                toga, predmet daje i direktno primjenjiva znanja naročito u
                područjima vezanim za marketing menadžment i opšti poslovni
                menadžment. U okviru predmeta studenti izučavaju tradicionalni
                marketing koncept transakcione orijentacije sa akcentom na
                elemente marketing miksa kao i ključne komponente savremene
                relacione orijentacije primijenjenog marketinga. Ovladavanje
                osnovama marketing koncepta omogućuje formiranje rigoroznih
                ličnih i grupnih kriterija poslovne efektivnosti i efikasnosti
                na strateškom i taktičkom nivou, što je neophodno ne samo
                marketing menadžerima nego i menadžerima na svim nivoima
                organizacije preduzeća. Sadržaj predmeta obuhvata i osnove
                upravljanja marketingom – marketing menadžmenta.
              </p>
              <h3>Sadržaj predmeta</h3>
              <div className="values-section">
                <p>
                  <strong>Teorijska nastava:</strong>
                </p>
                <ul>
                  <li>
                    Marketing kao poslovna filozofija; Tržište, faktori tražnje
                    i okruženje privrednog subjekta;
                  </li>
                  <li>
                    Marketing informisanje: odlučivanje i sistem informisanja u
                    marketingu, istraživanje tržišta;
                  </li>
                  <li>
                    Marketing miks: proizvod (pojam i nivoi proizvoda, obelježja
                    proizvoda, životni ciklus proizvoda, upravljanje
                    proizvodom), cijena (uloga i značaj cijena, determinante
                    formiranja cijena, metodi formiranja cijena, oblici cijena),
                    distribucija (pojam i uloga distribucije, kanali
                    distribucije, fizička distribucija), promocija
                    (komunikacioni aspekti promocije, promocija kao instrument
                    upravljanja tražnjom, utvrđivanje promocionog budžeta,
                    komponente promocionog miksa – oglašavanje, lična prodaja,
                    unapređenje prodaje, odnosi s javnošću);
                  </li>
                  <li>
                    Upravljanje marketingom: proces upravljanja marketingom,
                    faze planiranja marketinga, kontrola marketinga,
                    organizovanje marketinga (okvir i determinante organizovanja
                    marketinga, modeli organizacije marketinga).
                  </li>
                </ul>
              </div>
              <div className="values-section">
                <p>
                  <strong>Praktična nastava:</strong>
                </p>
                <p>
                  Praktična nastava prati teorijska predavanja uz primjenu
                  sledećih važnijih metoda:
                </p>
                <ul>
                  <li>Interaktivni rad</li>
                  <li>Pojedinačne i grupne prezentacije</li>
                  <li>Analiza praktičnih slučajeva</li>
                  <li>Diskusije na zadatu temu</li>
                  <li>Kreativna radionica</li>
                </ul>
              </div>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja nastavnika praćena su odgovarajućim posebno izrađenim
                prezentacijama. Za sve kategorije predviđeni su primjeri iz
                prakse odnosno iz realnog ambijenta. Kod izvođenja definicija i
                prvog predstavljanja određenog pojma ili kategorije predviđeno
                je aktivno uključenje studenata uz usmjeravanje nastavnika.
                Vježbe su bazirane prvenstveno na elaboraciji primjera iz
                prakse.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>Marketing kao poslovna filozofija</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Tržište, faktori tražnje i okruženje privrednog subjekta
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Marketing informisanje: odlučivanje i sistem informisanja
                      u marketingu, istraživanje tržišta
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Marketing miks: proizvod (pojam i nivoi proizvoda,
                      obelježja proizvoda, životni ciklus proizvoda, upravljanje
                      proizvodom)
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Marketing miks: cijena (uloga i značaj cijena,
                      determinante formiranja cijena, metodi formiranja cijena,
                      oblici cijena)
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Marketing miks: distribucija (pojam i uloga distribucije,
                      kanali distribucije, fizička distribucija)
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Marketing miks: promocija (komunikacioni aspekti
                      promocije, promocija kao instrument upravljanja tražnjom)
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>utvrđivanje promocionog budžeta</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>
                      komponente promocionog miksa – oglašavanje, lična prodaja,
                      unapređenje prodaje, odnosi s javnošću
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Upravljanje marketingom: proces upravljanja marketingom
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>faze planiranja marketinga</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>kontrola marketinga</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      organizovanje marketinga (okvir i determinante
                      organizovanja marketinga, modeli organizacije marketinga)
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 345 h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 215 h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Marketing;
